<template>
  <div>
    <div class="alert alert-success mt-3">
      <div class="row">
        <div class="col-1 d-flex border-right">
          <icon :icon="['fad', 'info']" class="text-info fa-3x mx-auto my-auto"/>
        </div>
        <div class="col" v-if="this.$route.params.transfer === 'cc'">
          <h5>Payment by credit card</h5>
          Thank you for your credit card payment.<br>
          You will receive an invoice for your abstract submission shortly.<br>
          <br>
          For questions regarding the payment, please refer to <a href="mailto:fensforum_abstracts@kit-group.org">fensforum_abstracts@kit-group.org</a>.

          <br><br>
          <span class="text-danger"><b>!</b></span> Please note that your abstract is not yet submitted. Please proceed to step 5 to review your submission details and click "Submit" to complete your submission.
        </div>
        <div class="col" v-if="this.$route.params.transfer === 'bt'">
          <h5>Payment by bank transfer</h5>
          Thank you for submitting your abstract.<br>
          You will receive a payment order soon with all relevant information to finalise your payment via bank transfer.<br>
          <br>
          For questions regarding the payment, please refer to <a href="mailto:fensforum_abstracts@kit-group.org">fensforum_abstracts@kit-group.org</a>.
          <br><br>
          <span class="text-danger"><b>!</b></span>  Please note that your abstract is not yet submitted. Please proceed to step 5 to review your submission details and click "Submit" to complete your submission.
          <br><br>
          <span class="text-danger"><b>!</b></span>  Please note that your abstract submission will only be considered as fully completed upon payment of the abstract submission fee. For a bank transfer, a proof of payment (provided by the bank) needs to be sent by 23 April 2024 to <a href="mailto:fensforum_registration@kit-group.org">fensforum_registration@kit-group.org</a>.
        </div>
      </div>
<!--      <div class="row mt-3">-->
<!--        <div class="col offset-1">-->
<!--          <payment_status :abstract_id="this.$route.params.id" :transfer="this.$route.params.transfer"></payment_status>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="row mt-4">
      <div class="col d-flex">
        <router-link
            :to="'../../' + nextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)"
            class="ml-auto"
            v-if="hasNextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)">
          <button type="button" class="btn btn-info float-right">{{ wording[0].buttons.next }}
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import payment_status from "@/components/payment/payment_status";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: 'kit_success',
  components: {payment_status},
  computed: {
    ...mapState([
      'user', 'wording', 'settings', 'processing', 'abstract'
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType'
    ]),
  },
  created() {
    this.setProcess();
  },
  methods: {
    ...mapActions('payment', [
      'PAYMENT_PROCESS'
    ]),
    ...mapActions(['PUT_ABSTRACT']),
    setProcess() {
      this.abstract.payment_process = true;
      this.abstract.payment_transfer = this.$route.params.transfer;
      this.PUT_ABSTRACT(this.$route.params.id).then((result) => {
        this.$noty.success(this.wording[0].notify.save_success);
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      });
    }
  }
}

</script>

<style scoped>

</style>
